import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useTranslation } from '@/hooks/useTranslation';

const ContentSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-16 bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 gradient-text">
            {t('aboutPage.content.title')}
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            {t('aboutPage.content.subtitle')}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="mb-16">
            <p className="text-lg text-center mb-12">
              {t('aboutPage.content.intro')}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <Card className="bg-white border-none shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="p-8">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                      <CheckCircle className="h-8 w-8 text-blue-600" />
                    </div>
                    <h3 className="text-xl font-bold mb-4">{t('aboutPage.content.cards.first.title')}</h3>
                    <p className="text-gray-600">
                      {t('aboutPage.content.cards.first.description')}
                    </p>
                  </div>
                </CardContent>
              </Card>
              
              <Card className="bg-white border-none shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="p-8">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                      <CheckCircle className="h-8 w-8 text-blue-600" />
                    </div>
                    <h3 className="text-xl font-bold mb-4">{t('aboutPage.content.cards.second.title')}</h3>
                    <p className="text-gray-600">
                      {t('aboutPage.content.cards.second.description')}
                    </p>
                  </div>
                </CardContent>
              </Card>
              
              <Card className="bg-white border-none shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="p-8">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                      <CheckCircle className="h-8 w-8 text-blue-600" />
                    </div>
                    <h3 className="text-xl font-bold mb-4">{t('aboutPage.content.cards.third.title')}</h3>
                    <p className="text-gray-600">
                      {t('aboutPage.content.cards.third.description')}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-gray-50 rounded-2xl shadow-xl overflow-hidden mb-20 p-8">
            <div className="max-w-3xl mx-auto">
              <p className="text-lg mb-6 leading-relaxed">
                {t('aboutPage.content.mission.first')}
              </p>
              <p className="text-lg mb-10 leading-relaxed">
                {t('aboutPage.content.mission.second')}
              </p>
              
              <h3 className="text-2xl font-bold mb-8 text-center">{t('aboutPage.serviceModels.title')}</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <Card className="bg-white border-none shadow-md overflow-hidden">
                  <div className="h-2 bg-blue-600"></div>
                  <CardContent className="p-8">
                    <h4 className="text-xl font-bold mb-4">{t('aboutPage.serviceModels.first.title')}</h4>
                    <p className="mb-6 text-gray-700">
                      {t('aboutPage.serviceModels.first.description')}
                    </p>
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <p className="font-medium text-blue-700 flex items-start">
                        <span className="mr-2 text-xl">👉</span>
                        <span>{t('aboutPage.serviceModels.first.ideal')}</span>
                      </p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white border-none shadow-md overflow-hidden">
                  <div className="h-2 bg-orange-500"></div>
                  <CardContent className="p-8">
                    <h4 className="text-xl font-bold mb-4">{t('aboutPage.serviceModels.second.title')}</h4>
                    <p className="mb-6 text-gray-700">
                      {t('aboutPage.serviceModels.second.description')}
                    </p>
                    <div className="bg-orange-50 p-4 rounded-lg">
                      <p className="font-medium text-orange-700 flex items-start">
                        <span className="mr-2 text-xl">👉</span>
                        <span>{t('aboutPage.serviceModels.second.ideal')}</span>
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentSection; 